import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Loadable from "react-loadable";
import { get, find } from "lodash";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
// import qs from "qs";
import {
  checkConfirm,
  insertPatient,
  updateSelectedPatient,
  resetConfirmCheck,
  verifyInfoPatient
} from "~/store/patient/patientAction";
import { getInfoFollowHospital } from "~/utils/flowRouting";
import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PatientVerifyInfomationPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_mobile" */ "~/components/desktop/pages/PatientVerifyInfomation"
    ),
  loading: LoadableLoading
});
const PatientVerifyInfomationPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_desktop" */ "~/components/desktop/pages/PatientVerifyInfomation"
    ),
  loading: LoadableLoading
});

class DetectPatientVerifyInfomation extends Component {
  methods = {
    changeConfirm: e => {
      this.props.handleCheckConfirm();
    },
    // checkConfirm: () => {
    //   const { selectedFeatureBooking } = this.props;
    //   if (this.props.confirmChecked) {
    //     const {
    //       selectedPatient,
    //       user,
    //       selectedFeature,
    //       selectedHospital
    //     } = this.props;
    //     this.props.updateSelectedPatient(selectedPatient);
    //     if (
    //       this.props.location.search &&
    //       qs.parse(this.props.location.search, {
    //         ignoreQueryPrefix: true
    //       }).back
    //     ) {
    //       this.props.insertPatient(
    //         {
    //           ...selectedPatient,
    //           user_id: user.user_id,
    //           access_token: user.access_token
    //         },
    //         () =>
    //           this.props.history.push(
    //             qs.parse(this.props.location.search, {
    //               ignoreQueryPrefix: true
    //             }).back
    //           )
    //       );
    //     } else {
    //       this.props.insertPatient({
    //         ...selectedPatient,
    //         user_id: user.user_id,
    //         access_token: user.access_token
    //       });

    //       let routerNextStep = "";
    //       if (selectedFeatureBooking) {
    //         routerNextStep = processFlowRouting(
    //           selectedFeatureBooking.id,
    //           selectedHospital
    //         ).routingAfterChoosePatient;
    //       } else {
    //         routerNextStep = processFlowRouting(
    //           selectedFeature.id,
    //           selectedHospital
    //         ).routingAfterChoosePatient;
    //       }
    //       this.props.history.push(routerNextStep);
    //     }
    //   }
    // },
    handleVerifyInfoPatient: () => {
      this.props.verifyInfoPatient();
    }
  };

  componentDidMount() {
    this.props.resetConfirmCheck();
    const {
      selectedPatient,
      match: {
        params: { state }
      }
    } = this.props;
    if (!state) return;

    const { selectedHospital } = this.props;
    const { router } = getInfoFollowHospital(selectedHospital.id);
    if (!selectedPatient) {
      this.props.history.push(`${router}/${state}`);
    }
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <PatientVerifyInfomationPageMobile
            {...this.props}
            {...this.methods}
          />
        ) : (
          <PatientVerifyInfomationPageDesktop
            {...this.props}
            {...this.methods}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user: { info },
    patient: { selectedPatient, confirmChecked, loading },
    features: { selectedFeature, selectedFeatureBooking },
    hospital: { selectedHospital }
  } = state;
  return {
    device: type,
    user: info,
    selectedPatient,
    confirmChecked,
    selectedFeature,
    loading,
    selectedHospital,
    selectedFeatureBooking
  };
};

const mapDispatchToProps = dispatch => ({
  handleCheckConfirm: () => {
    dispatch(checkConfirm());
  },
  updateSelectedPatient: patient => {
    dispatch(updateSelectedPatient(patient));
  },
  insertPatient: (data, callback) => {
    dispatch(insertPatient(data, callback));
  },
  resetConfirmCheck: () => {
    dispatch(resetConfirmCheck());
  },
  verifyInfoPatient: () => {
    dispatch(verifyInfoPatient());
  }
});

const PatientVerifyInfomationHelmet = withTitle({
  component: DetectPatientVerifyInfomation,
  title: `${hospitalName.value} | Xác nhận thông tin bệnh nhân`
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PatientVerifyInfomationHelmet));
